<app-breadcrumb [links]="[{link: 'admin', name: 'Administração'}]" current="Marcas"></app-breadcrumb>
<div class="backgroundColor star-dust darken-3">
  <section class="container-fluid backgroundColor star-dust darken-3 position-relative top-119" id="my-element">
    <div class="container mb-5">
      <div class="row pt-20 d-flex justify-content-center">
        <div class="col-6">
          <h1 class="text-white text-shadow">Inserção de Marcas</h1>
        </div>
        <div class="col-6 d-flex justify-content-end">
          <app-backtoadmin></app-backtoadmin>
        </div>       
      </div>
      <div class="row mt-20 d-flex justify-content-between">
        <div class="col-12 col-md-4 col-lg-4 fixedHeight">
          <ng-container *ngFor="let item of marcas">
            <div class="row d-flex justify-content-center mb-2">
              <div class="card p-4 d-flex justify-content-center model-border" style="width:290px;">
                <div class="mx-auto">
                  <img src="https://{{apiUrl}}/api/marcas/image/{{item.id}}/{{item.media?.split(';')[0]}}/" alt="..." class="img-fluid my-auto">
                </div>
                <div class="card-body text-center">
                  <h1 class="my-auto card-title text-white card-text-limit">{{item.nome}}</h1>
                  <div class="d-flex justify-content-center pt-4">
                    <button class="btn harvest-gold base card-link" (click)="deleteMarca(item)"><fa-icon [icon]="faTrash" class="fal fa-trash"></fa-icon></button>
                    <button class="btn shark lighten-3 card-link" (click)="bindMarca(item)"><fa-icon [icon]="faPencilAlt" class="fal fa-pencil-alt"></fa-icon></button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="col-12 col-md-6 col-lg-7 backgroundColor shark base py-10">
          <div *ngIf="itemMarca.id == 0"></div>
          <div class="form-group">
            <label class="text-white">Nome</label>&nbsp;
            <input class="form-control" type="text" [(ngModel)]="itemMarca.nome">
          </div>
          <app-selector class="text-white" [selection]="tipo" title="Tipo" [(selected)]="selTipo" [multiple]="true"></app-selector>
          <app-imageInput class="text-white" [(models)]="itemMarca.media" titulo="Imagens" btn="Ficheiros" [multiple]="true"></app-imageInput>
          <div class="form-group">
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="customSwitch2" [(ngModel)]="activate" (click)="sendConfirmation()">
              <label class="custom-control-label textColor white" for="customSwitch2">Link Externo</label>
            </div>
            <input class="form-control" type="text" [(ngModel)]="itemMarca.link" [disabled]="!activate">
          </div>
          <div class="mt-5">
            <button type="submit" class="btn harvest-gold position-absolute btn-pos mr-24" (click)="sendMarca()">Submeter</button>
            <button type="submit" class="btn btn-secondary position-absolute btn-pos " (click)="clear()">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>